module.exports = __webpack_public_path__ + "static/DownloadApp-70f7f51f57dfaec69f73fbe2bc367dfc.png";